import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'similar-events-carousel',
  templateUrl: './similar-events-carousel.component.html',
  styleUrls: ['./similar-events-carousel.component.scss'],
})
export class SimilarEventsCarouselComponent implements OnInit {
  @Input() title: string;
  @Input() eventsList: [];
  public slideOpts: any;
  constructor() {
    this.slideOpts = {
      spaceBetween: 20,
      freeMode: true,
      passiveListeners: true,
      slidesPerView: 1.8,
      pagination: {
        // clickable: true
      },
    };
  }
  ngOnInit(): void {
  }
}
